import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=0b2b6f32&scoped=true&"
import script from "./ContextMenu.vue?vue&type=script&lang=js&"
export * from "./ContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=0b2b6f32&scoped=true&lang=css&"
import style1 from "./ContextMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2b6f32",
  null
  
)

export default component.exports